import { render, staticRenderFns } from "./IconCopy.vue?vue&type=template&id=f98ef9c6&scoped=true&"
import script from "./IconCopy.vue?vue&type=script&lang=js&"
export * from "./IconCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98ef9c6",
  null
  
)

export default component.exports